import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { SectoresProductivosService } from 'src/app/services/sectores-productivos.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
var $;
@Component({
  selector: 'desEstandares',
  templateUrl: './desEstandares.component.html',
  styleUrls: ['./desEstandares.component.css']
})
export class DesEstandaresComponent implements OnInit {
  ocupacion: any;
  certificadores: any;
  desc: any;
  idEstandar: any;
  fecPublicacion: any;
  dataSource: any;
  dataSource2: any;
  dataSource3: any;
  dataSource4: any;
  iframe: boolean = false;
  displayedColumns: string[] = ['ocupaciones'];
  displayedColumns2: string[] = ['razonSocial'];
  displayedColumns3: string[] = ['integrantes'];
  displayedColumns4: string[] = ['cursos'];
  razonSocial: any;
  siglas: any;
  calleNumero: any;
  colonia: any;
  localidad: any;
  delegacion: any;
  entidadFederativa: any;
  fecha: any;
  telefono: any;
  correo: any;
  sitio: any;
  codigoPostal: any;
  codigoECO: any;


  presidente: any;
  puestoPresidente: any;
  vicepresidente: any;
  puestoVicepresidente: any;
  contacto: any;
  calleNumeroC: any;
  coloniaC: any;
  localidadC: any;
  delegacionC: any;
  entidadFederativaC: any;
  telefonoC: any;
  correoC: any;
  idComite: any;
  integrantes: any;
  cursos: any;
  urlpdf: any;
  col: boolean = false;
  col2: boolean = false;
  togle1: boolean = true;
  togle2: boolean = true;
  togle3: boolean = true;
  togle4: boolean = true;
  togle5: boolean = true;

  fechaCon: string;
  fax: string;
  clave: string;

  nombreCurso: string;
  objetivo: string;
  modulos: string;
  nombreCap: string;
  calleCap: string;
  coloniaCap: string;
  localidadCap: string;
  entidadFedCap: string;
  municipioCap: string;
  cpCap: string;
  telefonoCap: string;
  paginaWebCap: string;
  mail: string;
  modalidad: string;

  mostrarCertificadores:  boolean = false;
  mostrarCursos: boolean = false;

  @Output()
  sectorEsById = new EventEmitter<any>();
  @Output()
  backTo = new EventEmitter<number>();

  @Input() idSector: number;
  @Input() title: string;
  @Input() padre: number;
  @Input() codigoEC: string;
  @Input() hijo: number;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private service: SectoresProductivosService) {
  }

  ngOnInit(): void {
    this.getDesc(this.codigoEC);
  }

  back() {
    if(this.hijo == undefined && this.hijo == 0)
       this.backTo.emit(this.idSector);
    else{
      let flags: any = {
        nivel: true,
        ocupacion: false,
        sector: false,
        estandar: false,
        detalle: false
      };
      this.backTo.emit(flags);
    }   
  }
  home() {
    window.location.reload();
  }


  ifram() {
    if (this.iframe) {
      this.iframe = false;
    } else {
      this.iframe = true;
    }

  }

  async getFichaEstandar(idEstandar: number){
    let get = await this.service.getFichaEstandar(idEstandar);
    const source = `data:application/pdf;base64,${get}`;  
    const urlToFile = async (url, filename, mimeType) => {
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      return new File([buf], filename, { type: mimeType });
    };
    (async () => {
      const file = await urlToFile(source,`${this.codigoEC}.pdf`, 'application/pdf');
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    })();
  }

  async getDesc(codigoEC) {
    let get: any;
    get = await this.service.getDescEstandar(codigoEC);
    this.ocupacion = get.ocupaciones;
    this.desc = get.descripcion;
    this.fecPublicacion = get.fechaPublicacion;
    this.idEstandar = get.idEstandarCompetencia;
    this.dataSource = new MatTableDataSource<any>(this.ocupacion)
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.certificadores = get.certificadoras;
    this.dataSource2 = new MatTableDataSource<any>(this.certificadores)
    this.dataSource2.paginator = this.paginator;
    this.dataSource2.sort = this.sort;

    let get2: any;
    get2 = await this.service.getDatosGeneralesComite(this.codigoEC);

    this.presidente = get2.presidente;
    this.puestoPresidente = get2.puestoPresidente;
    this.vicepresidente = get2.vicepresidente;
    this.puestoVicepresidente = get2.puestoVicepresidente;
    this.contacto = get2.contacto;
    this.calleNumeroC = get2.calleNumero;
    this.coloniaC = get2.colonia;
    this.localidadC = get2.localidad;
    this.delegacionC = get2.delegacion;
    this.entidadFederativaC = get2.entidadFederativa;
    this.telefonoC = get2.telefono;
    this.correoC = get2.correo;
    this.idComite = get2.idComite;
    this.integrantes = get2.integrantes;
    this.cursos = get2.cursos;
    if(this.cursos.length > 0){
      this.mostrarCursos = true;
    }else{
      this.mostrarCursos = false;
    }
    if(this.integrantes > 0){
      this.mostrarCertificadores = true;
    }else{
      this.mostrarCertificadores = false;
    }
    this.dataSource3 = new MatTableDataSource<any>(this.integrantes)
    this.dataSource3.paginator = this.paginator;
    this.dataSource3.sort = this.sort;

    this.dataSource4 = new MatTableDataSource<any>(this.cursos)
    this.dataSource4.paginator = this.paginator;
    this.dataSource4.sort = this.sort;
  }

  async getDatos(clAcreditacion: any) {
    let get: any;
    get = await this.service.getDesCertificador(clAcreditacion, this.codigoEC);
    this.col = true;
    this.razonSocial = get.razonSocial;
    this.siglas = get.siglas;
    this.calleNumero = get.calleNumero;
    this.colonia = get.colonia;
    this.localidad = get.localidad;
    this.entidadFederativa = get.entidadFederativa;
    this.fecha = get.fecha;
    this.telefono = get.telefono;
    this.correo = get.correo;
    this.sitio = get.sitio;
    this.codigoPostal = get.codigoPostal;
    this.clave = get.clave;
    this.fechaCon = get.fechaCon;
    this.fax = get.fax;
  }

  collapseOpen(nombre: any, id: any) {

    var elemento = document.getElementById(nombre);
    var collapse1 = document.getElementById("collapse1");
    var collapse2 = document.getElementById("collapse2");
    var collapse3 = document.getElementById("collapse3");
    var collapse4 = document.getElementById("collapse4");
    if (this.mostrarCursos)
      var collapse5 = document.getElementById("collapse5");
    switch (id) {
      case 1:
        if (this.togle1) {
          elemento.className = "panel-collapse collapse show"
          collapse2.className = "panel-collapse collapse hide"
          collapse3.className = "panel-collapse collapse hide"
          collapse4.className = "panel-collapse collapse hide"
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide"
          this.togle1 = false;
          this.togle2 = true;
          this.togle3 = true;
          this.togle4 = true;
          this.togle5 = true;
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle1 = true;
        }
        break;
      case 2:
        if (this.togle2) {
          elemento.className = "panel-collapse collapse show"
          this.togle2 = false;
          this.togle1 = true;
          this.togle3 = true;
          this.togle4 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide"
          collapse3.className = "panel-collapse collapse hide"
          collapse4.className = "panel-collapse collapse hide"
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide"
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle2 = true;
        }
        break;

      case 3:
        if (this.togle3) {
          elemento.className = "panel-collapse collapse show"
          this.togle3 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle4 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide"
          collapse2.className = "panel-collapse collapse hide"
          collapse4.className = "panel-collapse collapse hide"
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide"
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle3 = true;
        }
        break;
      case 4:
        if (this.togle4) {
          elemento.className = "panel-collapse collapse show"
          this.togle4 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle3 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide"
          collapse2.className = "panel-collapse collapse hide"
          collapse3.className = "panel-collapse collapse hide"
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide"
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle4 = true;
        }
        break;
      case 5:
        if (this.togle5) {
          elemento.className = "panel-collapse collapse show"
          this.togle5 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle3 = true;
          this.togle4 = true;
          collapse1.className = "panel-collapse collapse hide"
          collapse2.className = "panel-collapse collapse hide"
          collapse3.className = "panel-collapse collapse hide"
          collapse4.className = "panel-collapse collapse hide"
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle5 = true;
        }
        break;
    }
  }

  async getDatosCurso(idCurso: any) {
    let get: any;
    get = await this.service.getCursoById(idCurso);
    this.col2 = true;
    this.nombreCurso = get.nombreCurso;
    this.objetivo = get.descripcion;
    this.modulos = get.modulos;
    this.nombreCap = get.nombreCapa;
    this.calleCap = get.calle;
    this.coloniaCap = get.colonia;
    this.localidadCap = get.localidad;
    this.entidadFedCap = get.entidad;
    this.municipioCap = get.municipio;
    this.cpCap = get.cp;
    this.telefonoCap = get.telefono;
    this.paginaWebCap = get.pagWeb;
    this.mail = get.email;
    this.modalidad = get.modalidad;
  }

}
